import ACTIONS from '../actionTypes/company';
import CompanyService from '../../services/CompanyService';
import { getCurrentUserSession } from './user';

export const setUserSelectedCompany = (company) => {
  if (!company) return null;
  return (dispatch) => {
    dispatch({ type: ACTIONS.SET_USER_SELECTED_COMPANY, payload: company });
    dispatch(getCurrentUserSession(company.Key))
  }
};

export const setUserSelectedApiDocsCompany = (company) => {
  if (!company) return null;
  return (dispatch) => {
    dispatch({ type: ACTIONS.SET_USER_SELECTED_API_DOCS_COMPANY, payload: company });
  }
};

export const setUserCompanyList = () => {
  return (dispatch, getState) => {
    return CompanyService.getAllUserCompanies().then((res) => {
      if (res.data && res.data.length > 0) {
        // set selected contract main company as default
        const { contract: { selectedContract } } = getState();
        const companyKey = selectedContract?.customer?.companyKey || res.data[0].Key;
        dispatch(setUserSelectedCompany(res.data?.find(e => e.Key == companyKey)));
      }
      dispatch({ type: ACTIONS.SET_USER_COMPANY_LIST, payload: res.data });
    }).catch(() => { });
  };
};

export const clearCompanyStore = () => {
  return { type: ACTIONS.CLEAR_COMPANY_STORE }
};

export const setCompanyUsers = (allUsers) => {
  return { type: ACTIONS.SET_COMPANY_USERS, payload: allUsers }
};